'use strict';

require('../../style/');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/list/style/index.js
// module id = 1117
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 19 22 24 26 27 29 31 36 37 38 39